
import {Component, Mixins, Prop} from "vue-property-decorator";
import PermissionService from "@pazion/pazion-core/src/services/permission-service";

@Component()
export default class PazTooltipButton extends Mixins(PermissionService) {

  @Prop({default: false})
  public xLarge!: boolean;

  @Prop({default: ''})
  public tooltip!: string;

  @Prop({default: ''})
  public requiredProfileFlag!: string;

  @Prop({default: false})
  public disabled!: boolean;

  @Prop({default: false})
  public loading!: boolean;

  @Prop({default: 'primary'})
  public color!: string;

  @Prop({default: false})
  public mouseEvent!: boolean;

  @Prop({default: ''})
  public icon!: string;

  @Prop({default: false})
  public noclick!: boolean;

  triggerMouse(e: MouseEvent) {
    if (!this.mouseEvent) {
      return;
    }
    this.$emit("mouse", e);
  }

  get getToopTip() {
    if (this.hasRequiredPermission) {
      return this.tooltip;
    }
    return 'NO PERMISSION!';
  }

  get devToopTip() {
    return `Required flag: '${this.requiredProfileFlag}'`
  }

  get hasRequiredPermission(): boolean {
    if (this.requiredProfileFlag == '') {
      return true;
    }
    return this.hasProfileFlag(this.requiredProfileFlag);
  }

  onclick(event) {
    if (this.noclick) {
      return;
    }
    this.$emit("click", event);
  }
}
